// LoaderModal.jsx
import React from "react";

const Loader = ({ open, text = "Loading..." }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white rounded-lg p-6 flex flex-col items-center shadow-lg">
        {/* Spinner */}
        <div className="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
        
        {/* Text */}
        <p className="mt-3 text-gray-700 font-medium">{text}</p>
      </div>
    </div>
  );
};

export default Loader;
